<template>
    <el-container class="home-container">
        <el-header>
            <div>
                <span style="font-size:25px">VOM乐器租售后台管理系统</span>
            </div>
            <div>
                <el-select v-model="site" size="small" style="width: 140px; margin-right: 10px;" @change="changeSite">
                    <el-option label="小程序" value="miniapp"></el-option>
                    <el-option label="网站" value="web"></el-option>
                </el-select>
                <el-button @click="editDialogVisible = true">修改密码</el-button>
                <el-button type="" @click="LogOut">退出</el-button>
            </div>
        </el-header>
        <el-container>
            <el-aside width="200px">
                <el-menu default-active="2" background-color="#fff" text-color="#6e6e6e" active-text-color="#409EFF" unique-opened router style="height: 100%">
                    <el-submenu index="1">
                        <template slot="title">
                        <i class="el-icon-s-home"></i>
                        <span>首页管理</span>
                        </template>
                        <el-menu-item index="/swipers"  @click="saveNavState('/swipers')"><i class="el-icon-menu"></i>轮播图列表</el-menu-item>
                        <el-menu-item index="/pianos"  @click="saveNavState('/pianos')"><i class="el-icon-menu"></i>名琴欣赏</el-menu-item>
                        <el-menu-item index="/courses"  @click="saveNavState('/courses')"><i class="el-icon-menu"></i>在线课程</el-menu-item>
                        <el-menu-item index="/abouts"  @click="saveNavState('/abouts')"><i class="el-icon-menu"></i>关于VOM</el-menu-item>
                    </el-submenu>
                    <el-submenu index="2">
                        <template slot="title">
                        <i class="el-icon-user-solid"></i>
                        <span>用户管理</span>
                        </template>
                        <el-menu-item index="/dealers" @click="saveNavState('/dealers')"><i class="el-icon-menu"></i>经销商列表</el-menu-item>
                        <el-menu-item index="/users" @click="saveNavState('/users')"><i class="el-icon-menu"></i>用户列表</el-menu-item>
                    </el-submenu>
                    
                    <el-submenu index="3">
                        <template slot="title">
                        <i class="el-icon-s-goods"></i>
                        <span>商品管理</span>
                        </template>
                        <el-menu-item index="/goodsclass"  @click="saveNavState('/goodsclass')"><i class="el-icon-menu"></i>商品类型</el-menu-item>
                        <el-menu-item index="/goodslist"  @click="saveNavState('/goodslist')"><i class="el-icon-menu"></i>商品列表</el-menu-item>
                    </el-submenu>
                    <el-submenu index="4">
                        <template slot="title">
                        <i class="el-icon-s-order"></i>
                        <span>订单管理</span>
                        </template>
                        <el-menu-item index="/orderlist"  @click="saveNavState('/orderlist')"><i class="el-icon-menu"></i>订单列表</el-menu-item>
                    </el-submenu>
                    <el-submenu index="5">
                        <template slot="title">
                        <i class="el-icon-message-solid"></i>
                        <span>问题管理</span>
                        </template>
                        <el-menu-item index="/questions"  @click="saveNavState('/questions')"><i class="el-icon-menu"></i>问题列表</el-menu-item>
                    </el-submenu>
                    <el-submenu index="6"  v-if="admin_token == 'admin'">
                        <template slot="title">
                        <i class="el-icon-s-tools"></i>
                        <span>参数管理</span>
                        </template>
                        <el-menu-item index="/params"  @click="saveNavState('/params')"><i class="el-icon-menu"></i>参数设置</el-menu-item>
                    </el-submenu>
                </el-menu>
            </el-aside>
            <el-main>
                <router-view></router-view>
            </el-main>
        </el-container>
        <!--修改密码对话框-->
        <el-dialog title="修改密码" :visible.sync="editDialogVisible" width="40%" @close="editDialogClosed">
            <el-form :model="editForm" :rules="editFormRules" ref="editFormRef" label-width="100px">
                <el-form-item label="原密码" prop="password">
                    <el-input v-model="editForm.password" show-password></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="new_password">
                    <el-input v-model="editForm.new_password" show-password></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="con_password">
                    <el-input v-model="editForm.con_password" show-password></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="editPass">确 定</el-button>
            </span>
        </el-dialog>
        <!--修改密码对话框-->
    </el-container>
</template>
<script>
export default {
    data(){
        //验证原密码规则
        var oldPass = (rule, value, callback) => {
            if (value !== this.old_password) {
            callback(new Error('原密码不正确!'));
            } else {
            callback();
            }
        }
        //验证确认密码规则
        var validatePass = (rule, value, callback) => {
            if (value !== this.editForm.new_password) {
            callback(new Error('两次输入密码不一致!'));
            } else {
            callback();
            }
        }
        return {
            isCollapse: false,
            activePath: '',
            site: 'miniapp',
            editDialogVisible:false,
            old_password:'',
            editForm:{
                 password:'',
                 new_password:'',
                 con_password:''
            },
            editFormRules: {
                password: [
                    { required: true, message: '请输入原密码', trigger: 'blur' },
                    { validator: oldPass, trigger: 'blur'}
                ],
                new_password: [
                    { required: true, message: '请输入新密码', trigger: 'blur' },
                    { min: 6, max: 8, message: '长度在 6 到 8 个字符', trigger: 'blur' }
                ],
                con_password:[
                    { required: true, message: '请输入确认密码', trigger: 'blur' },
                    { validator: validatePass, trigger: 'blur'}
                ],
            }
        }
    },
    created() {
        this.activePath = window.sessionStorage.getItem('activePath')
        this.admin_token = window.sessionStorage.getItem('admin_token')
        this.old_password = window.sessionStorage.getItem('pass_token')
        this.site = window.sessionStorage.getItem('site') || 'miniapp'
        window.sessionStorage.setItem('site', this.site)
	},
    methods:{
        changeSite(site) {
            window.sessionStorage.setItem('site', site)
            this.$message.success('已切换站点')
            window.location.reload()
        },
        saveNavState(activePath) {
			window.sessionStorage.setItem('activePath', activePath)
			this.activePath = activePath
			
        },
        LogOut(){
            window.sessionStorage.clear();
            this.$router.push('/admin');
        },
        editDialogClosed(){
           this.$refs.editFormRef.resetFields()
       },
       editPass(){
           this.$refs.editFormRef.validate( async valid => {
                if(!valid) return;
                const { data: res } = await this.$http.post('editpass/',{username:this.admin_token,password:this.editForm.new_password})
                if (res.status === 0) {
                    this.$message.success('密码修改成功！')
                    this.editDialogVisible = false
                }
            })
       },
       Print(){
           console.log('3333333333333')
       }
    }
}
</script>
<style>
    .home-container{
        padding-top:0px;
        height: 100%;
    }
    .el-header{
        /* background-color: #153d77; */
        background-image: linear-gradient(to right,#6f82e1,#5165f8);
        display: flex;
        justify-content: space-between;
        padding-left: 100px;
        align-items: center;
        font-size: 20px;
        color: #fff;
        height: 100px !important;
    }
    .el-aside{
	    background-color: #fff;
    }
    .el-main {
        background-color:#FAFAFA;
    }
    .el-menu {
		border-right: none;
    }
    .el-submenu :hover{
        background-color: lightblue !important;
    }
</style>